import { render } from "./Flipdown.vue?vue&type=template&id=bab60bd2"
import script from "./Flipdown.vue?vue&type=script&setup=true&lang=js"
export * from "./Flipdown.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"scripts/governance/Flipdown.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bab60bd2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bab60bd2', __exports__)) {
    api.reload('bab60bd2', __exports__)
  }
  
  module.hot.accept("./Flipdown.vue?vue&type=template&id=bab60bd2", () => {
    api.rerender('bab60bd2', render)
  })

}


export default __exports__